import { useEffect, useState } from 'react'

import { type LeadFormOfferRemaining, getLeadFormOfferRemaining } from './leadFormOfferCountdown'

export const useLeadFormOfferCountdown = (offerEndsAt: Date | null): LeadFormOfferRemaining | null => {
    const [remaining, setRemaining] = useState<LeadFormOfferRemaining | null>(() =>
        offerEndsAt ? getLeadFormOfferRemaining(offerEndsAt) : null,
    )

    useEffect(() => {
        if (!offerEndsAt) {
            setRemaining(null)
            return
        }

        const tick = () => {
            const next = getLeadFormOfferRemaining(offerEndsAt)
            setRemaining(next)
            return next.isExpired
        }

        if (tick()) {
            return
        }

        const intervalId = window.setInterval(() => {
            if (tick()) {
                window.clearInterval(intervalId)
            }
        }, 1000)

        return () => window.clearInterval(intervalId)
    }, [offerEndsAt])

    return remaining
}
